// ReSharper disable once InconsistentNaming
import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import $ from "jquery";
import { t } from "../../../shared/translation";

let autoplayDelay: number | null = null;
let startTime: number | null = null;
let currentSlideIndex: number = 0;
let swiperWithProgressBar: Swiper | null = null;
// ReSharper disable once ConstructorCallNotUsed
const DEFAULT_AUTOPLAY_DELAY = 5000; // Default 5 seconds per slide

function syncHeroImageWidth(img: HTMLImageElement): void {
    if (img.naturalWidth) {
        img.style.setProperty("--img-width", `${img.naturalWidth}px`);
    }
}

function initHeroImageWidths(): void {
    document.querySelectorAll<HTMLImageElement>(".hero-slide-image img").forEach((img) => {
        if (img.complete && img.naturalWidth) {
            syncHeroImageWidth(img);
        }
        // Always listen – <picture> may swap source on resize
        img.addEventListener("load", () => syncHeroImageWidth(img));
    });
}

window.InitializeCarousels = function () {
    initHeroImageWidths();
    // return;
    $(".swiper-container").each(function (_index, elem) {
        const $elem = $(elem);
        if ($elem.hasClass("swiper-container-initialized")) return;

        $elem.attr({
            role: "group",
            "aria-roledescription": t("DigitalPresence.Shared.Carousel.RoleDescription", "carousel")
        });

        $elem.find(".swiper-wrapper").attr({
            "aria-atomic": "false",
            "aria-live": "off"
        });

        const totalSlides: number = $elem.find(".swiper-slide").length;
        $elem.find(".swiper-slide").each(function (index, slide) {
            $(slide).attr(
                "aria-label",
                t(
                    "DigitalPresence.Shared.Carousel.SlideLabel",
                    "{0} of {1}",
                    (index + 1).toString(),
                    totalSlides.toString()
                )
            );
        });

        let breakPoints;

        const slides = Number($elem.data("slides") ?? 3);

        switch (slides) {
            case 6:
                breakPoints = {
                    575: {
                        slidesPerView: 2,
                        spaceBetween: 24
                    },
                    760: {
                        slidesPerView: 4,
                        spaceBetween: 24
                    },
                    960: {
                        slidesPerView: 6,
                        spaceBetween: 24
                    }
                };
                break;
            case 4:
                breakPoints = {
                    0: {
                        slidesPerView: 1,
                        spaceBetween: 16
                    },
                    575: {
                        slidesPerView: 2,
                        spaceBetween: 24
                    },
                    760: {
                        slidesPerView: 3,
                        spaceBetween: 24
                    },
                    960: {
                        slidesPerView: 4,
                        spaceBetween: 24
                    }
                };
                break;
            case 3:
                breakPoints = {
                    400: {
                        slidesPerView: 1,
                        spaceBetween: 24
                    },
                    600: {
                        slidesPerView: 2,
                        spaceBetween: 24
                    },
                    960: {
                        slidesPerView: 3,
                        spaceBetween: 24
                    }
                };
                break;
            case 2:
                breakPoints = {
                    600: {
                        slidesPerView: 1,
                        spaceBetween: 24
                    },
                    960: {
                        slidesPerView: 2,
                        spaceBetween: 24
                    }
                };
                break;
            default:
                breakPoints = {
                    0: {
                        slidesPerView: 1,
                        spaceBetween: 24
                    }
                };
        }

        autoplayDelay =
            $elem.data("autoplay") && $elem.data("progressBar") ? Number($elem.data("autoplay")) : autoplayDelay;

        try {
            new Swiper(elem, {
                modules: [Navigation, Pagination, Autoplay],
                autoHeight: ($elem.data("autoheight") as boolean) || false,
                loop: ($elem.data("loop") as boolean) || false,
                centeredSlides: ($elem.data("centered") as boolean) || false,
                autoplay: $elem.data("autoplay") ? { delay: Number($elem.data("autoplay")) } : false,
                pagination: {
                    el: $elem.find(".swiper-pagination")[0],
                    dynamicBullets: ($elem.find(".swiper-pagination").data("dynamicbullets") as boolean) || false,
                    clickable: true
                },
                navigation: {
                    nextEl: $elem.find(".swiper-button-next")[0],
                    prevEl: $elem.find(".swiper-button-prev")[0]
                },
                breakpoints: breakPoints,

                on: {
                    init: (swiper): void => {
                        // Start progress animation
                        swiperWithProgressBar = $elem.data("progressBar") ? swiper : swiperWithProgressBar;

                        if ($elem.data("progressBar") as boolean) {
                            setTimeout(() => {
                                requestAnimationFrame((timestamp) => updateProgress(swiper, timestamp));
                            }, 100);
                        }
                    },
                    slideChange: (): void => {
                        if ($elem.data("progressBar") as boolean) {
                            setTimeout(() => {
                                if (swiperWithProgressBar) {
                                    currentSlideIndex = swiperWithProgressBar.realIndex;
                                    $(".slide-link").removeClass("active");
                                    $(`.slide-link[data-index="${currentSlideIndex}"]`).addClass("active");
                                    startTime = null;
                                }
                            }, 100);
                        }
                    }
                }
            });
        } catch {
            // No catch
            console.log("Exception in carousel");
        }

        const buttons = $elem.find(".slide-link");

        buttons.on("click", function (this: HTMLElement) {
            const index = Number($(this).data("index"));

            if (swiperWithProgressBar) {
                currentSlideIndex = index;
                swiperWithProgressBar.slideTo(index);
                startTime = null;
            }
        });
    });

    const updateProgress = (swiper: Swiper, timestamp: number): void => {
        startTime ??= timestamp;
        const progressBar = $("#swiper-progress-bar");
        const links = $(".slide-link");

        const elapsed = timestamp - startTime;
        const currentIndex = swiper.realIndex;
        const currentThumb = links.eq(currentIndex);
        const currentTextWidth = currentThumb.find("div").width() ?? 0;

        const currentLeft = currentThumb.position()?.left ?? 0;

        const progress = (elapsed / (autoplayDelay ?? DEFAULT_AUTOPLAY_DELAY)) * currentTextWidth;
        const progressPosition = currentLeft + progress;

        progressBar.css({
            left: `${progressPosition}px`,
            width: "30px",
            transform: "translateX(-50%)",
            transition: currentIndex === 0 && swiper.previousIndex === links.length - 1 ? "none" : "left 0.3s ease-out"
        });

        if (progress >= currentTextWidth) {
            if (currentIndex === links.length - 1) {
                swiper.slideTo(0);
            } else {
                swiper.slideNext();
            }
            startTime = timestamp;
        }

        requestAnimationFrame((newTimestamp) => updateProgress(swiper, newTimestamp));
    };
};

$(window.InitializeCarousels);
